var $06581167229ef22c$exports = {};
const { search: $06581167229ef22c$var$queryParams } = document.location;
if ($06581167229ef22c$var$queryParams.length > 0 && $06581167229ef22c$var$queryParams.includes('utm_')) window.localStorage.setItem('savedQueryParams', $06581167229ef22c$var$queryParams.slice(1));


//# sourceMappingURL=saveQueryParams.5f2b8c34.js.map
